import "rxjs/add/operator/mergeMap";
import "rxjs/add/observable/fromPromise";

import { Types, Creators } from "../reducer";
import { normalizeEmail, normalizePhone } from "../../common/normalize";

import * as firebase from 'firebase';

const created = registration => Creators.registrationCreated(registration.key);
const setCurrent = registration =>
  Creators.setCurrentRegistration(registration.key);

const createRegistration = action =>
  firebase.database().ref("registrations").push({
    ...action.data,
    ...(action.data.email && { email: normalizeEmail(action.data.email) }),
    ...(action.data.phone && { phone: normalizePhone(action.data.phone) }),
    created: Date.now(),
    updated: Date.now()
  });

export default (action$, store) =>
  action$
    .ofType(Types.CREATE_REGISTRATION)
    .mergeMap(createRegistration)
    .flatMap(registration => [created(registration), setCurrent(registration)]);



// WEBPACK FOOTER //
// ./src/registration/epics/createRegistration.js